module.exports = __webpack_public_path__ + "static/media/pp_boy4.0e77c124.svg";